export default __webpack_public_path__ + "static/media/crypto_phones_mobile.d07de804.png";